import React, { useEffect, useState } from "react";
import Dashboard from "../../Components/Dashboard";
import { store } from "../../store";
import useStyle from "../Ebook/style";
import Denied from "../../Components/Denied";
import { apiLabs, apiSpreadsheet } from "../../Services/api";
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { toast } from "react-toastify";

function RetiraJa(props) {
  const {
    location: { idPage },
  } = props;

  const [auth, setAuth] = useState(null);

  const [data, setData] = useState({
    csv: "",
  });

  const style = useStyle();

  async function verifyAuth() {
    const { profile } = store.getState().user;
    const res = await apiLabs.post("valid_key", {
      id: profile.id,
      menu_id: idPage,
    });
    if (res.data.message === "User not authorized") {
      return setAuth("denied");
    }
    if (res.data.message === "User authorized") {
      return setAuth("authorized");
    }
  }

  const uploadSpreadsheet = (e) => {
    const csv = e.target.files[0] ? e.target.files[0] : [];
    if (csv.length !== 0) {
      if (!csv.name.includes("csv")) {
        e.target.value = "";
        setData({
          csv: "",
        });
        toast.error("Formato inválido, por favor selecione um formato válido");
        return;
      }
    }
    setData({
      ...data,
      [e.target.id]: csv,
    });
  };

  const clearFields = () => {
    setData({
      csv: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = new FormData();
    const fields = data.csv !== "";

    if (fields) {
      e.target.csv.value = "";
    }

    obj.append("csv", data.csv);

    try {
      if (fields) {
        await apiSpreadsheet.post("/", obj);
        toast.success("Planilha enviada com sucesso");
        clearFields();
      } else {
        toast.error("Preencha os campos");
      }
    } catch (error) {
      toast.error("Preencha o campo");
      console.error(error);
    }
  };

  useEffect(() => {
    verifyAuth();
  }, []);

  return (
    <>
      <Dashboard title="Retira Já">
        {auth === "denied" && <Denied />}
        {auth === "authorized" && (
          <Container className={`${style.fullWidth} ${style.containerEbook}`}>
            <form
              onSubmit={(e) => handleSubmit(e)}
              encType="multipart/form-data"
              style={{ maxWidth: 900, width: "100%", padding: 25 }}
            >
              <Grid className={style.ebookForm}>
                <Box className={`${style.formInput}`}>
                  <Typography className={style.title}>
                    Planilha SKU's
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{ fontSize: "0.875rem" }}
                  >
                    Obs: Planilha de no máximo 200 SKU's
                  </Typography>
                  <TextField
                    accept=".csv"
                    id="csv"
                    label="Planilha de SKU's"
                    placeholder="Planilha de SKU's"
                    onChange={(e) => uploadSpreadsheet(e)}
                    margin="normal"
                    type="file"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    name="csv"
                  />
                </Box>
              </Grid>
              <Grid className={style.button}>
                <Button type="submit">Salvar</Button>
              </Grid>
            </form>
          </Container>
        )}
      </Dashboard>
    </>
  );
}

export default RetiraJa;
